import React, { useEffect, useState } from "react";
import { Info } from "lucide-react";
import api from "@/lib/api";
import { eaParams, useEa } from "./EaContext";
import { useSelectedCodes } from "./EaControls";

// Pagine che usano le curve: avvisa se alcuni POD non hanno curve o sono a risoluzione oraria.
export function EaCurveNote({ pun }) {
  const { filters, ready } = useEa();
  const codes = useSelectedCodes();
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!ready) return;
    api.get("/ea/power/curve-coverage", { params: eaParams(filters, { codes }) }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [ready, filters.company, filters.year, codes]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d || !d.points_total) return null;
  const missing = d.points.filter((p) => p.resolution === "NONE");
  const hourly = d.points.filter((p) => p.resolution === "HOURLY" || p.resolution === "MIXED");
  if (!missing.length && !hourly.length) return null;
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900 flex gap-2" data-testid="ea-curve-note">
      <Info size={16} className="shrink-0 mt-0.5" />
      <div>
        {missing.length > 0 && <div data-testid="ea-curve-note-missing">Analisi sulle curve di consumo su <b>{d.points_with_curves} di {d.points_total} POD</b>: esclusi {missing.map((p) => p.identifier).join(", ")} (solo consumi mensili).{pun ? " PUN ponderato, picco e costo teorico sono riferiti ai soli POD con curve." : ""}</div>}
        {hourly.length > 0 && <div data-testid="ea-curve-note-hourly">Curve a risoluzione oraria (ripartite in 4 quarti uguali) per {hourly.map((p) => `${p.identifier}${p.resolution === "MIXED" ? ` (${p.hourly_days} giorni)` : ""}`).join(", ")}: i valori a 15 minuti e i picchi sono medie orarie.</div>}
      </div>
    </div>
  );
}
